import React, { useState, useRef } from "react";
import Modal from "../modal/Modal";

const VideoPreview = ({ src, width = 200 }) => {
  const [visible, setVisible] = useState(false);
  const videoRef = useRef(null);

  const handleClose = () => {
    setVisible(false);
    // Pause the video when modal closes
    if (videoRef.current) {
      videoRef.current.pause();
    }
  };

  return (
    <>
      <video src={src} width={width} style={{ cursor: "pointer" }} onClick={() => setVisible(true)} />
      <Modal open={visible} doOnClose={handleClose} width={600} modalCloseIcon={true}>
        {src && <video ref={videoRef} src={src} width="100%" controls autoPlay />}
      </Modal>
    </>
  );
};

export default VideoPreview;
